import React, { useEffect, useState, useRef } from 'react'
import { Typography, Box, Button } from '@mui/material'
import Skeleton from 'react-loading-skeleton'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import { LineChart } from '@mui/x-charts'
import CompactFilterLayout from '@/components/partials/CompactFilterLayout'
import DateRange from '@/components/partials/DateRange'
import filterImage from '@/assets/img/icons/filter.svg'

const INITIAL_FILTERS = {
    date_from: null,
    date_to: null,
}

function CustomersChart({ endpoint = 'customers/chart' }) {
    const [loading, setLoading] = useState(true)
    const [chartData, setChartData] = useState([])
    const [filters, setFilters] = useState(INITIAL_FILTERS)

    const compactFilterLayoutRef = useRef(null)
    const fetchDebounceRef = useRef(null)

    useEffect(() => {
        clearTimeout(fetchDebounceRef.current)
        fetchDebounceRef.current = setTimeout(() => {
            setLoading(true)
            Api.get(`${endpoint}?date_from=${filters.date_from || ''}&date_to=${filters.date_to || ''}`)
                .then(res => {
                    if (res.data && res.data.success) {
                        setChartData(res.data.data)
                    }
                    setLoading(false)
                })
                .catch(() => setLoading(false))
        }, 300)
        return () => clearTimeout(fetchDebounceRef.current)
    }, [filters, endpoint])

    function handleFilterChange(name, value) {
        setFilters(prev => ({ ...prev, [name]: value }))
    }

    function getAppliedFiltersCount() {
        return filters.date_from || filters.date_to ? 1 : 0
    }

    const labels = chartData.map(d => d.label)
    const counts = chartData.map(d => d.count)

    function getIfAnyCustomers() {
        return chartData.some(
            (item) => item.count > 0
        )
    }

    return (
        <div className='customers-chart'>
            <div className='head'>
                <h3>
                    {trans('labels.addedCustomers')}
                </h3>
                <div className="right">
                    <Button onClick={(e) => {
                        compactFilterLayoutRef.current.open(e)
                    }}>
                        <img src={filterImage} alt="Filter" />
                        {getAppliedFiltersCount() ?
                            <i>{getAppliedFiltersCount()}</i>
                            : <></>}
                    </Button>
                    <CompactFilterLayout
                        ref={compactFilterLayoutRef}
                        appliedFiltersCount={getAppliedFiltersCount()}
                        onClearClick={() => setFilters(INITIAL_FILTERS)}
                    >
                        <div className='row'>
                            <div className='col'>
                                <DateRange
                                    startDate={filters.date_from || ''}
                                    endDate={filters.date_to || ''}
                                    onStartDateChange={(date) => handleFilterChange('date_from', date)}
                                    onEndDateChange={(date) => handleFilterChange('date_to', date)}
                                />
                            </div>
                        </div>
                    </CompactFilterLayout>
                </div>
            </div>
            <hr />
            {loading ?
                <Skeleton height={300} count={1} /> :
                !getIfAnyCustomers() ?
                    <div
                        className="alert warning"
                        style={{
                            marginBottom: 0,
                            width: "100%",
                        }}
                    >
                        {trans("messages.noDataFound")}
                    </div>
                    :
                    <LineChart
                        xAxis={[{
                            data: labels,
                            scaleType: 'point',
                        }]}
                        series={[{
                            data: counts,
                            area: true,
                            color: '#181F67',
                            showMark: true,
                        }]}
                        height={287}
                        // margin={{ left: 50, right: 20, top: 20, bottom: 30 }}
                        grid={{ horizontal: true }}
                        sx={{
                            '& .MuiAreaElement-root': {
                                fill: 'url(#customers-gradient)',
                            },
                            '& .MuiLineElement-root': {
                                strokeWidth: 1,
                            },
                            '& .MuiMarkElement-root': {
                                stroke: '#fff',
                                strokeWidth: 1,
                                fill: '#181F67',
                                r: 5,
                            },
                            '& .MuiChartsGrid-line': {
                                stroke: '#e0e0e0',
                                strokeDasharray: '4 2',
                            },
                        }}
                    >
                        <defs>
                            <linearGradient id="customers-gradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#181F67" stopOpacity={0.25} />
                                <stop offset="100%" stopColor="#181F67" stopOpacity={0.02} />
                            </linearGradient>
                        </defs>
                    </LineChart>
            }
        </div>
    )
}

export default CustomersChart
